import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["spinPrefixCls", "className", "size", "tip", "wrapperClassName", "style"];
import classNames from "classnames";
import { debounce } from "lodash";
import omit from "rc-util/lib/omit";
import * as React from "react";
import { ConfigConsumer, ConfigContext } from "../ConfigProvider/context";
import { cloneElement, isValidElement } from "../hack/_util/reactNode";
import { tuple } from "../hack/_util/type";
import { IconLoading } from "../Icons/IconLoading";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SpinSizes = tuple("small", "default", "large");
// Render indicator
var defaultIndicator = null;
function renderIndicator(prefixCls, props) {
  var indicator = props.indicator;
  var dotClassName = "".concat(prefixCls, "-dot");

  // should not be render default indicator when indicator value is null
  if (indicator === null) {
    return null;
  }
  if (isValidElement(indicator)) {
    return cloneElement(indicator, {
      className: classNames(indicator.props.className, dotClassName)
    });
  }
  if (isValidElement(defaultIndicator)) {
    return cloneElement(defaultIndicator, {
      className: classNames(defaultIndicator.props.className, dotClassName)
    });
  }
  return /*#__PURE__*/_jsx("span", {
    className: classNames(dotClassName, "".concat(prefixCls, "-dot-spin")),
    children: /*#__PURE__*/_jsx(IconLoading, {
      size: 40
    })
  });

  // return (
  //     <span className={classNames(dotClassName, `${prefixCls}-dot-spin`)}>
  //         <i className={`${prefixCls}-dot-item`} />
  //         <i className={`${prefixCls}-dot-item`} />
  //         <i className={`${prefixCls}-dot-item`} />
  //         <i className={`${prefixCls}-dot-item`} />
  //     </span>
  // );
}

function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}
var Spin = /*#__PURE__*/function (_React$Component) {
  _inherits(Spin, _React$Component);
  var _super = _createSuper(Spin);
  function Spin(_props) {
    var _this;
    _classCallCheck(this, Spin);
    _this = _super.call(this, _props);
    _defineProperty(_assertThisInitialized(_this), "originalUpdateSpinning", void 0);
    _defineProperty(_assertThisInitialized(_this), "debouncifyUpdateSpinning", function (props) {
      var _ref = props || _this.props,
        delay = _ref.delay;
      if (delay) {
        _this.cancelExistingSpin();
        _this.updateSpinning = debounce(_this.originalUpdateSpinning, delay);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateSpinning", function () {
      var spinning = _this.props.spinning;
      var currentSpinning = _this.state.spinning;
      if (currentSpinning !== spinning) {
        _this.setState({
          spinning: spinning
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderSpin", function (_ref2) {
      var _classNames;
      var direction = _ref2.direction;
      var _this$props = _this.props,
        prefixCls = _this$props.spinPrefixCls,
        className = _this$props.className,
        size = _this$props.size,
        tip = _this$props.tip,
        wrapperClassName = _this$props.wrapperClassName,
        style = _this$props.style,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var spinning = _this.state.spinning;
      var spinClassName = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === "small"), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === "large"), _defineProperty(_classNames, "".concat(prefixCls, "-spinning"), spinning), _defineProperty(_classNames, "".concat(prefixCls, "-show-text"), !!tip), _defineProperty(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);

      // fix https://fb.me/react-unknown-prop
      var divProps = omit(restProps, ["spinning", "delay", "indicator", "prefixCls"]);
      var spinElement = /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, divProps), {}, {
        style: style,
        className: spinClassName,
        "aria-live": "polite",
        "aria-busy": spinning,
        children: [renderIndicator(prefixCls, _this.props), tip ? /*#__PURE__*/_jsx("div", {
          className: "".concat(prefixCls, "-text"),
          children: tip
        }) : null]
      }));
      if (_this.isNestedPattern()) {
        var containerClassName = classNames("".concat(prefixCls, "-container"), _defineProperty({}, "".concat(prefixCls, "-blur"), spinning));
        return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, divProps), {}, {
          className: classNames("".concat(prefixCls, "-nested-loading"), wrapperClassName),
          children: [spinning && /*#__PURE__*/_jsx("div", {
            children: spinElement
          }, "loading"), /*#__PURE__*/_jsx("div", {
            className: containerClassName,
            children: _this.props.children
          }, "container")]
        }));
      }
      return spinElement;
    });
    var _spinning = _props.spinning,
      _delay = _props.delay;
    var shouldBeDelayed = shouldDelay(_spinning, _delay);
    _this.state = {
      spinning: _spinning && !shouldBeDelayed
    };
    _this.originalUpdateSpinning = _this.updateSpinning;
    _this.debouncifyUpdateSpinning(_props);
    return _this;
  }
  _createClass(Spin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSpinning();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.debouncifyUpdateSpinning();
      this.updateSpinning();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelExistingSpin();
    }
  }, {
    key: "cancelExistingSpin",
    value: function cancelExistingSpin() {
      var updateSpinning = this.updateSpinning;
      if (updateSpinning && updateSpinning.cancel) {
        updateSpinning.cancel();
      }
    }
  }, {
    key: "isNestedPattern",
    value: function isNestedPattern() {
      return !!(this.props && typeof this.props.children !== "undefined");
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx(ConfigConsumer, {
        children: this.renderSpin
      });
    }
  }]);
  return Spin;
}(React.Component);
_defineProperty(Spin, "defaultProps", {
  spinning: true,
  size: "default",
  wrapperClassName: ""
});
var SpinFC = function SpinFC(props) {
  var customizePrefixCls = props.prefixCls;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var spinPrefixCls = getPrefixCls("spin", customizePrefixCls);
  var spinClassProps = _objectSpread(_objectSpread({}, props), {}, {
    spinPrefixCls: spinPrefixCls
  });
  return /*#__PURE__*/_jsx(Spin, _objectSpread({}, spinClassProps));
};
SpinFC.setDefaultIndicator = function (indicator) {
  defaultIndicator = indicator;
};
// @ts-ignore
if (process.env.NODE_ENV !== "production") {
  SpinFC.displayName = "Spin";
}
export default SpinFC;